import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #EF443C 0%, #C43931 100%);
  color: white;
  padding: 4rem;
`;

const Title = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 4rem;
  text-align: center;
`;

const ChaosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  max-width: 1200px;
  margin-bottom: 4rem;
`;

const PainCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 3rem;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const PainIcon = styled.div`
  font-size: 5rem;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
`;

const PainLabel = styled.div`
  font-size: 1.8rem;
  font-weight: 600;
  text-align: center;
`;

const MainQuestion = styled(motion.div)`
  background: rgba(4, 46, 75, 0.9);
  padding: 3rem 5rem;
  border-radius: 25px;
  font-size: 3rem;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 900px;
`;

const KeywordsRow = styled(motion.div)`
  display: flex;
  gap: 3rem;
  margin-top: 3rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const Keyword = styled.div`
  font-size: 2rem;
  font-weight: 600;
  padding: 1rem 2.5rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  border: 2px solid white;
`;

const Slide3Dor: React.FC = () => {
  const pains = [
    { icon: '📅', label: 'Sem Prazos' },
    { icon: '☑️', label: 'Sem Métricas' },
    { icon: '📉', label: 'Sem Controle' },
  ];

  return (
    <Container>
      <Title
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        A Dor Principal
      </Title>

      <ChaosGrid>
        {pains.map((pain, index) => (
          <PainCard
            key={index}
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{
              duration: 0.3,
              delay: 0.1 + index * 0.08,
              type: 'spring',
              stiffness: 100,
            }}
          >
            <PainIcon>{pain.icon}</PainIcon>
            <PainLabel>{pain.label}</PainLabel>
          </PainCard>
        ))}
      </ChaosGrid>

      <MainQuestion
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.4 }}
      >
        "Estou perdendo competitividade?"
      </MainQuestion>

      <KeywordsRow
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.5 }}
      >
        <Keyword>Desordem</Keyword>
        <Keyword>Incerteza</Keyword>
        <Keyword>Risco</Keyword>
      </KeywordsRow>
    </Container>
  );
};

export default Slide3Dor;
